import React, { useState } from "react";
import { render } from "../common/reactUtils";

interface props {
}

export default function ScrollToTop(props: props) {

    const [showButton, setShowButton] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const scrollLimit = 600;

    const handleWindowScroll = () => {
        const $window = $(window);
        const scrollTop = $window.scrollTop();
        if(scrollTop && scrollTop > scrollLimit) {
            setShowButton(true);
        }
        else {
            setShowButton(false);
        }
    }

    window.addEventListener('scroll', handleWindowScroll);    

    return (
    <>
        { showButton &&
            <button onClick={scrollToTop} className="scroll-to-top__button">
                <div className="scroll-to-top__wrapper">
                    Till toppen
                </div>
            </button>
        }
    </>
    );
}



export const initialize = () => {
    render(<ScrollToTop/>, "#scroll-to-top");    
};